import { Icon } from "assets/icons/Icon";
import FuncButtonStyled from "./FuncButtonStyled";

const FilterButton = ({ filters, ...props }) => {
	const isActive = () => {
		let active = false;
		if (!filters) active = false;
		for (const key in filters) {
			if (filters[key] === "" || filters[key]?.length > 0) {
				active = true;
				break;
			}
		}
		return active;
	};

	return (
		<FuncButtonStyled
			type="button"
			{...props}
			isActive={isActive()}
		>
			<Icon icon="filter" />
			Filters
		</FuncButtonStyled>
	);
};

export default FilterButton;
